<template>
  <div class="uk-position-center">
    <div class="uk-width-1-1 uk-grid">
      <div class="uk-width-1-1">
        <div class="uk-flex uk-flex-center">
          <img :src='icon'>
        </div>
      </div>
    </div>
    <h1 class="heading uk-text-center">{{errorHeading}}</h1>
    <span v-if="errorDescription.a">
      <p class="description uk-text-center uk-margin-small">{{errorDescription.a}}<br>{{errorDescription.b}}</p>
    </span>
    <p v-else class="description uk-text-center uk-margin-small">{{errorDescription}}</p>
    <div class="uk-width-1-1 uk-text-center">
      <span class="code">{{errorCode}}</span>
    </div>
    <div v-if="showSearch" class="uk-width-1-1 search-container">
      <div class="uk-flex uk-flex-center">
        <hr>
      </div>
      <div class="uk-text-center uk-margin-small search-message">
        <p>{{$t('error.searchForMore')}}</p>
      </div>
      <div class="uk-flex uk-flex-center">
        <form v-on:submit.prevent="submitSearch" class="uk-width-1-1 uk-search uk-search-default uk-align-center">
          <input class="search-box uk-search-input" type="search"
                 placeholder="Search SMART Exchange" v-model="searchText" autocomplete="off" required id="Search">
          <router-link :to="{name: 'Search', query:{searchText, key: new Date().getTime()}}">
          <img class="uk-search-icon-flip" :src='searchSlate'>
          </router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'

  export default {
    name: 'error-sharelink',
    props: ['errorHeading', 'errorDescription', 'errorCode', 'showSearch'],
    data() {
      return {
        icon: iconUtil.resolve(misc.ERROR_INFO_ICON),
        searchSlate: iconUtil.resolve(misc.SEARCH_ICON)
      }
    },
    computed: {
      ...mapGetters(['searchTerm']),
      searchText: {
        get: function () {
          return this.searchTerm
        },
        set: function (newVal) {
          this.setSearchCriteria({searchText: newVal})
        }
      }
    },
    methods: {
      ...mapActions(['performSearch', 'setSearchCriteria', 'cleanSetSearchCriteria']),
      submitSearch() {
        this.cleanSetSearchCriteria(this.searchText)
        this.performSearch({searchText: this.searchText})
      }
    },
    watch: {
      searchTerm(value, newValue) {
        this.searchText = value
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  hr {
    width: 659px;
    height: 2px;
  }

  form {
    position: relative;
  }

  .search-container {
    margin-top: 29px;
  }

  .errorCode {
    margin-bottom: 100px;
  }

  .uk-search-icon-flip {
    width: 52px;
    height: 53px;
  }

  .uk-heading-primary {
    color: rgba(0, 1, 2, 0.7);
  }

  .heading {
    font-size: 20px;
    font-weight: bold;
    color: rgba(0, 1, 2, 0.7);
  }

  .description {
    font-size: 16px;
    color: rgba(0, 1, 2, 0.7);
  }

  .search-message {
    margin-top: 9px;
    font-size: 26px;
    line-height: 1.77;
  }

  .uk-search-default .search-box {
    height: 48px;
    font-size: 14px;
    opacity: 0.75;
    width: 490px;
    padding-left: 25px;
    margin-top: -5px;
  }

  .uk-search-default {
    height: 48px;
    width: 550px;
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding-left: 0px;
    .uk-search-input {
      border: 0px solid #e5e5e5;
    }
  }

  input::placeholder {
    color: $slate !important;
    padding-right: 12px;
  }

  .code {
    font-size: 16.8px;
    line-height: 32.9px;
    color: rgba(0, 1, 2, 0.4);
  }

  @media screen and (min-width: $breakpoint-medium) {
    .heading {
      font-size: 38px;
    }
    .description {
      font-size: 28px;
    }
    .uk-search-default .search-box {
      height: 67px;
      font-size: 20px;
      padding-left: 25px;
      width: 490px;
      margin-top: 0px;
    }
    .uk-search-default {
      height: 67px;
    }
    .code {
      font-size: 24px;
    }
  }

  @media screen and (min-width: $breakpoint-xlarge) {
    .heading {
      font-size: 41px;
    }
    .description {
      font-size: 33px;
    }
    .uk-search-default .search-box {
      height: 69px;
      font-size: 24px;
      width: 538px;
      padding-left: 25px;
      margin-top: 0px;
    }
    .uk-search-default {
      height: 69px;
      width: 597px;
    }
    .code {
      font-size: 24px;
      line-height: 1.96;
    }
  }

</style>
